export const PaymentAlternativeChoice = Object.freeze(
    {
        "free_payment":100,
        "swish_directly":1,
        "swish_via_swedbank_pay":2,
        "vipps_via_swedbank_pay":3,
        "mobile_pay_via_swedbank_pay":4,
        "card_via_swedbank_pay":5,
        "bank_transaction_via_swedbank_pay":6,
    });